import * as React from "react";
import classnames from "classnames";
import { Modal, Button } from "@grandvisionhq/common";
import { Heading, Hr } from "@grandvisionhq/elements";
import { Select } from "@grandvisionhq/forms";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css                       */
const PauseSubscriptionModal = ({
  className,
  pauseDurationOptions,
  onCancel,
  onPause,
  isLoading,
  errorMessage
}) => {
  const intl = useIntl();
  const [selection, setSelection] = React.useState(pauseDurationOptions[0]);
  const formattedDurations = React.useMemo(
    () => pauseDurationOptions.reduce((acc, option) => {
      const durationLabelKey = option.amount === 1 ? option.unit.slice(0, -1) : option.unit;
      const durationLabel = `${option.amount} ${intl.getLabel(
        `common.duration.${durationLabelKey.toLowerCase()}`
      )}`;
      return {
        ...acc,
        [durationLabel]: option
      };
    }, {}),
    [intl, pauseDurationOptions]
  );
  const onSelectChange = React.useCallback((duration) => {
    setSelection(duration);
  }, []);
  const handlePause = React.useCallback(() => {
    if (selection) {
      onPause(selection);
    }
  }, [onPause, selection]);
  const buttonCaption = isLoading ? intl.getLabel("common.loadingText") : intl.getLabel("account.ccc.pauseSubscription.actions.pause");
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      showIcon: true,
      isOpen: true,
      onModalClose: onCancel,
      "aria-label": intl.getLabel("account.ccc.pauseSubscription.title"),
      className: classnames("pause-ccc", className)
    },
    /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "pause-ccc__title" }, intl.getLabel("account.ccc.pauseSubscription.title")),
    /* @__PURE__ */ React.createElement(Hr, null),
    /* @__PURE__ */ React.createElement("p", { className: "pause-ccc__description" }, intl.getLabel("account.ccc.pauseSubscription.description")),
    /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, intl.getFormattedLabel("account.ccc.pauseSubscription.info", { parseLink: true })),
    errorMessage && /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, errorMessage),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "pause-duration-select",
        name: "pause-duration-select",
        className: "pause-ccc__select",
        options: formattedDurations,
        onChange: onSelectChange,
        label: intl.getLabel("account.ccc.pauseSubscription.select.label")
      }
    ),
    /* @__PURE__ */ React.createElement("div", { className: "pause-ccc__buttons" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: buttonCaption,
        className: "pause-ccc__button",
        "data-t": "pause-ccc-modal-confirm",
        onClick: handlePause,
        disabled: isLoading
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: intl.getLabel("common.actions.cancel"),
        className: "pause-ccc__button",
        "data-t": "pause-ccc-modal-cancel",
        onClick: onCancel,
        variant: "outline"
      }
    ))
  );
};
export {
  PauseSubscriptionModal as default
};
//# sourceMappingURL=PauseSubscription.js.map
